import { IonCard, IonCardContent, IonItem, IonIcon } from "@ionic/react";
import React from "react";
import { addOutline, removeOutline } from "ionicons/icons";
import { hapticsImpactMedium } from "../../../utils/core-utils/hapticUtils";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

interface AggPositionsAccordionProps {
  structuredPositions: any;
  expandedItems: (string | number)[];
  setExpandedItems: React.Dispatch<React.SetStateAction<(string | number)[]>>;
}

const PositionRowContent = ({
  e,
  isChild,
}: {
  e: any;
  isChild?: boolean;
  parentD?: string;
}) => {
  return (
    <div
      className="custom_positionsgrid_item"
      style={isChild ? { paddingRight: "35px" } : {}}
    >
      <div className="pg__contract_netpos_section">
        <div className="pg__contract_sub-section">
          {isChild ? `${e?.cc} ${e?.d}` : e?.cc}
        </div>
        <div
          className={`pg__netpos_sub-section ${
            e?.netPos?.isZero()
              ? ""
              : e?.netPos?.isPositive()
                ? "netpos_positive"
                : "netpos_negative"
          }`}
        >
          {e?.netPos?.toNumber()?.toLocaleString()}
        </div>
      </div>
      <div className="pg__buyqty_sellqty_section">
        <div className="pg__buyqty_sub-section">{e?.g?.f}</div>
        <div className="pg__sellqty_sub-section">{e?.gs?.f}</div>
      </div>
      <div className="pg__avgbuy_avgsell_section">
        <div className="pg__avgbuy_sub-section">{e?.ab?.f}</div>
        <div className="pg__avgsell_sub-section">{e?.asp?.f}</div>
      </div>
      <div className="pg__refprice_pnl_section">
        <div className="pg__refprice_sub-section">{e?.l?.f}</div>
        <div
          className={`pg__pnl_sub-section ${
            e?.pnl?.isZero()
              ? ""
              : e?.pnl?.isPositive()
                ? "pnl_positive"
                : "pnl_negative"
          }`}
        >
          {e?.pnl?.toNumber()?.toLocaleString()}
        </div>
      </div>
    </div>
  );
};

const AggPositionsAccordion: React.FC<AggPositionsAccordionProps> = ({
  structuredPositions,
  expandedItems,
  setExpandedItems,
}) => {
  const toggleItem = (id: string | number) => {
    setExpandedItems((prev) => {
      if (prev.includes(id)) {
        return prev.filter((itemId) => itemId !== id);
      }
      return [...prev, id];
    });
    hapticsImpactMedium();
  };

  return (
    <>
      {structuredPositions?.map((e: any, index: number) => {
        const currentId = e?.i;
        const isOpen = expandedItems.includes(currentId);
        const hasChildren = e?.children && e.children.length > 0;

        return (
          <IonCard
            key={index}
            style={{
              margin: "0px 0px 10px 0px",
              boxShadow: "none",
              background: "transparent",
              border: "none",
              padding: "0px",
              borderRadius: "0px",
            }}
            className="ion-no-padding"
          >
            <IonItem
              button={hasChildren}
              detail={false}
              onClick={() => hasChildren && toggleItem(currentId)}
              className="ion-no-padding animate__animated animate__fadeIn"
              lines="none"
              style={{
                "--min-height": "70px",
                "--background": "#112B4A",
                border: "6px solid var(--ion-color-light)",
                "--inner-padding-end": 0,
              }}
            >
              <PositionRowContent e={e} />
              {hasChildren && (
                <IonIcon
                  icon={isOpen ? removeOutline : addOutline}
                  slot="end"
                  style={{ color: "#fff", marginRight: "5px" }}
                  size="small"
                />
              )}
            </IonItem>
            {isOpen && (
              <IonCardContent className="positions__accordion_content ion-no-padding">
                {e?.children?.map((elem: any, index2: number) => (
                  <IonItem
                    color="light"
                    lines="none"
                    className="ion-no-padding"
                    style={{
                      "--inner-padding-end": 0,
                      "--min-height": "70px",
                      border: "6px solid transparent",
                      background: "var(--ion-color-light)",
                    }}
                    key={index2}
                  >
                    <PositionRowContent e={elem} isChild />
                  </IonItem>
                ))}
              </IonCardContent>
            )}
          </IonCard>
        );
      })}
    </>
  );
};

export default AggPositionsAccordion;
